import { render, staticRenderFns } from "./wujie-detail.vue?vue&type=template&id=792c049e"
import script from "./wujie-detail.vue?vue&type=script&lang=js"
export * from "./wujie-detail.vue?vue&type=script&lang=js"
import style0 from "./wujie-detail.vue?vue&type=style&index=0&id=792c049e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports